import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e0f0fbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "authorization" }
const _hoisted_2 = { class: "authorization__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "authorization__title" }, "Вход", -1))
const _hoisted_4 = { class: "authorization__rules" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Я согласен с правилами использования ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" и политиками сайта dianapp.online ")
const _hoisted_8 = { class: "authorization__sign-in" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Войти ")
const _hoisted_10 = { class: "authorization__recovery" }

import { reactive, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import type { FormInstance, FormRules } from 'element-plus'
import { AxiosErrorType, LoginDataType } from '@/shared/types'
import { authApi, userApi } from '@/shared/api'
import { useUser } from '@/shared/composables'
import { setToken, showErrorMessage } from '@/shared/utils'
import { COMMON_RULES } from '@/shared/constants'
import WHeaderAuth from '@/widgets/WHeaderAuth/WHeaderAuth.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()

const authorizationForm = ref<FormInstance>()
const isAgreeWithRules = ref(true)
const loading = ref(false)

const authorizationFormData: LoginDataType = reactive({
  email: '',
  password: '',
})

const authorizationValidationRules = reactive<FormRules>({
  email: [COMMON_RULES.emailRequired, COMMON_RULES.emailIncorrect],
  password: [COMMON_RULES.passwordRequired],
})

const { setUser, setIsAuth, user } = useUser()

const authorizationUser = async (
  token: string,
  expiresIn = 7
): Promise<void> => {
  const [error, organizationsResponse] = await authApi.getOrganizations()

  if (error) {
    if (error.length) {
      showErrorMessage(error)
    } else {
      router.push({ name: 'NewPasswordPage' })
    }

    loading.value = false
  } else {
    setToken(token, expiresIn)

    if (organizationsResponse.data.organizations.length === 1) {
      await authApi.setOrganization(
        organizationsResponse.data.organizations[0].id
      )

      const [_, userResponse] = await userApi.getInfoAboutMe()

      setUser(userResponse.data)
      setIsAuth(true)

      if (user.value.role === 'admin') {
        router.push({ name: 'UserListingPage' })
      } else {
        router.push({ name: 'PatientListingPage' })
      }
    } else {
      router.push({ name: 'ClinicChoicePage' })
    }
  }
}

const handleLogin = (form: FormInstance | undefined): void => {
  if (!form) return
  loading.value = true

  form.validate(async (valid): Promise<boolean> => {
    if (valid) {
      const [error, response] = await authApi.login(authorizationFormData)
      if (error) {
        console.log(error)
        loading.value = false
        const axiosError: AxiosErrorType = {
          errors: [error.errors[0] || 'Что-то пошло не так. Попробуйте позже'],
          status: error.status,
        }
        showErrorMessage(axiosError)

        return false
      }

      await authorizationUser(
        response.data.token,
        response.data.expires_in_days
      )
      console.log(route.query.redirect)
      router.push(route.query.redirect as string)
      return true
    } else {
      loading.value = false

      return false
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WHeaderAuth, { class: "layout__header" }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_form, {
        ref_key: "authorizationForm",
        ref: authorizationForm,
        model: _unref(authorizationFormData),
        rules: _unref(authorizationValidationRules),
        class: "authorization__form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            class: "authorization__form--item",
            prop: "email"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(authorizationFormData).email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(authorizationFormData).email) = $event)),
                autocomplete: "username",
                autofocus: "",
                class: "el-input--authorization",
                name: "email",
                placeholder: "Электронная почта",
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (this.$refs['password-input'].focus()), ["enter"]))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            class: "authorization__form--item",
            prop: "password"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                ref: "password-input",
                modelValue: _unref(authorizationFormData).password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(authorizationFormData).password) = $event)),
                class: "el-input--authorization",
                placeholder: "Пароль",
                "show-password": "",
                onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (handleLogin(authorizationForm.value)), ["enter"]))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_checkbox, {
          modelValue: isAgreeWithRules.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isAgreeWithRules).value = $event)),
          class: "el-checkbox--authorization"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          id: "btn",
          disabled: !isAgreeWithRules.value,
          class: "el-button--authorization authorization__sign-in--button",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (handleLogin(authorizationForm.value)))
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "authorization__text authorization__recovery--button",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/password-recovery')))
        }, " Восстановить пароль ")
      ])
    ])
  ])), [
    [
      _directive_loading,
      loading.value,
      void 0,
      { fullscreen: true }
    ]
  ])
}
}

})